export default __webpack_public_path__ + "static/media/Flag of Montenegro.fea18622.gif";